import * as React from 'react'

export const SvgLock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width={24} height={24} aria-hidden={true} {...props}>
    <path d="M7 9V7a5 5 0 1110 0v2h1a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2h1zm4 6.732V18h2v-2.268a2 2 0 10-2 0zM9 9h6V7a3 3 0 00-6 0v2z" />
  </svg>
)
export default SvgLock
